import { Chip, ButtonBase, makeStyles } from "@material-ui/core";
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import { useState } from "react";
import Toast from "./toast";
export function ToggleStatus({ onClick, active }) {
  const [state, setState] = useState(active);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const classes = useStyle();
  const handleClick = () => {
    const newStatus = !state;

    setState(newStatus);
    setLoading(() => true);
    onClick(newStatus)
      .then(() => {})
      .catch(() => {
        setState(!newStatus);
        setToast(true)
        setToastMessage('No se pudo actualizar el estado, intente nuevamente.')
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <Toast
        open={toast}
        message={toastMessage}
        close={() => setToast(false)}
      />
      <Chip
        className={classes.toogle_status}
        component={ButtonBase}
        data-status={state ? "active" : "inactive"}
        label={state ? "Activo" : "Inactivo"}
        icon={<FiberManualRecordRoundedIcon style={{ fontSize: "0.8rem" }} />}
        clickable
        onClick={handleClick}
        disabled={loading}
      />
    </>
  );
}
const useStyle = makeStyles((theme) => ({
  toogle_status: {
    width: "100%",
    fontSize:'0.9rem',
    '&[data-status="active"]': {
      backgroundColor: `hsl(from ${theme.palette.success.light} h s calc(l + 27))`,
      "& .MuiChip-icon": {
        color: theme.palette.success.main,
        filter:`drop-shadow(0 0px 6px ${theme.palette.success.main})`
      },
    },
    '&[data-status="inactive"]': {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      "& .MuiChip-icon": {
        color: theme.palette.grey[500],
      },
    },
  },
}));
